import _typeof from "@babel/runtime/helpers/typeof";
import store from './store';
var weblogin = {
  getUserInfo: function getUserInfo() {
    var userInfo = this.getUserInfoData();
    userInfo && (!userInfo.user || !userInfo.user.area) && this.reset();
    return userInfo ? userInfo.user : null;
  },
  isLogined: function isLogined() {
    var uinfo = this.getUserInfoData();
    return !!uinfo;
  },
  checkLogin: function checkLogin() {
    return this.isLogined();
  },
  getUserInfoData: function getUserInfoData() {
    if (store.get('userInfo')) {
      var userInfo = JSON.parse(window.Base64.fromBase64(store.get('userInfo')));
      if (_typeof(userInfo) === 'object' && !userInfo.deviceid && store.get('deviceid')) {
        userInfo.deviceid = store.get('deviceid');
      }
      return userInfo;
    }
  },
  reset: function reset() {
    store.remove('userInfo');
    store.remove('deviceid');
  },
  getAuthentication: function getAuthentication() {
    var info = this.getUserInfoData();
    if (info) {
      // const data = {
      // token:'XX14a26ec911cfa3f6f3411599cd17f925',
      // deviceID:'0c8e2b73-254a-4e68-be7a-07195dd98b31',
      // uid:'1211949222165880833',
      // thirdchannel:6
      //}
      var data = {
        token: info.token,
        deviceID: info.deviceid,
        uid: info.user.uid,
        thirdchannel: 6
      };
      return data;
    } else {
      return null;
    }
  }
};
export default weblogin;